import {z} from '@hono/zod-openapi';

export const supplierCatalogPartSchema = z
  .object({
    supplierOrderable: z.boolean().nullable(),
    sourceGroupCode: z.string().nullable().default(null).openapi({
      description: 'Opaque supplier group identifier. It is not a discount rate or tenant price.',
    }),
    oemCode: z.string(),
    name: z.string(),
    currency: z.literal('CZK'),
    purchasePrice: z.number().finite().nonnegative().nullable(),
    recommendedSellingPrice: z.number().finite().nonnegative(),
    active: z.boolean(),
    manufacturerNumberNormalized: z.string(),
  })
  .openapi('SupplierCatalogPart');
export type SupplierCatalogPart = z.infer<typeof supplierCatalogPartSchema>;
